module.exports = __webpack_public_path__ + "static/img/page_08.96f2ddcb.png";